<template>
    <div>
        <line-chart
            id="accumulatedResults"
            :data="areaData"
            xkey="date"
            :resize="true"
            :ykeys='yKeys'
            :labels='labels'
            lineColors='["#6e8cd7", "#d7856e"]'
            hideHover="auto"
            :parseTime="false"
            :lineWidth="3"
            :pointSize="3"
            fillOpacity="0.4"
            grid="true"
            gridTextFamily="Muli"
            gridTextColor="#65708B"
            :yLabelFormat="money"
        >
        </line-chart>
    </div>
</template>

<script>
import { LineChart } from 'vue-morris'

export default {
    components: {
        LineChart
    },
    props: ['areaData', 'currency', 'compare', 'marketName', 'marketNameCompare'],
    data() {
        return {
            yKeys: ['acumulado'],
            labels: [
                this.marketName,
            ]
        }
    },
    created() {
        if (this.compare) {

            this.yKeys = ['acumulado', 'acumulado_comp']

            this.labels = [
                this.marketName,
                this.marketNameCompare
            ]
        }
    },
    methods: {
        money(value) {
            return this.currency + ' ' + value;
        }
    }
}
</script>

<style>

</style>
